import styles from "./radioButton.module.scss";
import PropTypes from "prop-types";

const RadioButton = ({
                       items = [],
                       handleOnChange,
                       name,
                       selectedOption,
                       label,
                       className,
                       optionStyle,
                       labelStyle,
                       labelNameStyle,
                     }) => {
  const getSelectedLabel = (val) => {
    return items.some((itm) => itm.label === val && itm?.swatch_data !== null);
  };

  return (
    <div className={`${styles["radio-button"]} ${className} button-wrapper`}>
      <div className={styles["radio-button__text"] }>
        <label className={`${styles["radio-button__label"]} ${labelStyle}`}>
          {label}:
        </label>
        <span
          className={
            getSelectedLabel(selectedOption)
              ? `${styles["radio-button__label-name"]} ${labelNameStyle}`
              : null
          }
        >
					{getSelectedLabel(selectedOption) ? selectedOption : null}
				</span>
      </div>
      <div className={`${styles.radioOptions} ${label === 'Colour' ? styles.colorOptions : styles.defaultOptions}`}>
        {items.map((radio, index) => (
          <label
            className={`${styles["radio-button__clickable"]} `}
            key={index}
          >
            <input
              name={name}
              type="radio"
              value={radio.label}
              className={styles["radio-button__input-hidden"]}
              checked={selectedOption === radio.label}
              onChange={() => handleOnChange(radio.label)}
            />
            {/* <span className={styles["radio-button__checkmark"]}>
							{radio.label}
						</span> */}
            <span
              className={`${
                radio?.swatch_data?.value
                  ? styles["radio-button__coloring"]
                  : styles["radio-button__checkmark"]
              }`}
              style={
                radio?.swatch_data?.value && {
                  backgroundColor: radio?.swatch_data?.value,
                }
              }
            >
							{!radio?.swatch_data?.value && radio.label}
						</span>
            {radio?.swatch_data?.value && (
              <span className={styles["radio-button__checked"]}></span>
            )}
          </label>
        ))}
      </div>
    </div>
  );
};

RadioButton.defaultProps = {
  items: [],
  className: "",
  label: "",
};
RadioButton.propTypes = {
  items: PropTypes.array,
  handleOnChange: PropTypes.func,
  name: PropTypes.string,
  selectedOption: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
};

export default RadioButton;
